import React, { useState } from "react";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragEndEvent, TouchSensor, DragStartEvent, DragOverlay } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { IKanbanItemRecord, IKanbanTypeRecord } from "../../../lib/types";
import BoardItem from "./BoardItem";
import Button from "../../form/button";
import EditableField from "../../form/EditableField";

interface BoardTypeProps {
    type: IKanbanTypeRecord;
    items: IKanbanItemRecord[];
}

export default function BoardType({ type, items }: BoardTypeProps) {
    const [title, setTitle] = useState(type.title);
    const [kanbanItems, setKanbanItems] = useState<IKanbanItemRecord[]>(items.filter((i) => i.type === type.id));

    return (
        <div>
            <div className="mb-4 flex items-center justify-between gap-2 ">
                <h2 className="text-lg font-medium">
                    <EditableField value={title} onChange={setTitle} />
                </h2>
                <Button variant={"outline"} size={"box"}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                    </svg>
                </Button>
            </div>

            <div className="w-80 flex-shrink-0 rounded-lg border p-2 dark:bg-slate-950">
                <div className="scrollbar flex h-[calc(100dvh-18rem)] flex-col gap-2 overflow-y-scroll">
                    {kanbanItems.map((item) => (
                        <BoardItem item={item} />
                    ))}
                </div>
            </div>
        </div>
    );
}
